import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getSubscribes = async (updatedSince?: string): Promise<AxiosResponse> =>
  AxiosInstance.get('subscriptions.get', {
    params: {
      updatedSince,
    },
  });
